
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxStripeModule } from 'ngx-stripe';
import { filter, map, mergeMap } from 'rxjs';
import { StripeConfigService } from './service/stripe-config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stripeConfigService: StripeConfigService,
    private titleService: Title
  ) {}
  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        this.titleService.setTitle(event['title']);
      });

      //const publicKey = this.stripeConfigService.getPublicKey();  
      // 确保在此初始化 NgxStripeModule  
      //NgxStripeModule.forRoot(publicKey); // 在此调用 
  }
}
